/** GSD auth shell — icônes œil réutilisables (sans pack externe). */
import React from "react";

export function IconEye({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7-9.5-7-9.5-7Z" />
      <circle cx="12" cy="12" r="2.8" />
    </svg>
  );
}

export function IconEyeOff({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M3 3l18 18" />
      <path d="M10.6 6.3A10.4 10.4 0 0 1 12 5c6 0 9.5 7 9.5 7a17.4 17.4 0 0 1-3.4 4.4" />
      <path d="M6.1 6.2C3.9 7.8 2.5 12 2.5 12s3.5 7 9.5 7c1.4 0 2.7-.3 3.9-.8" />
      <path d="M9.9 9.9a2.8 2.8 0 0 0 4.2 4.2" />
    </svg>
  );
}
